import React from 'react';
import { NodeTile } from '../nodeTile';
import { NodeTypeLabel, NodeTiles, StyledNodeTileSection } from './NodeTilePanel.styled';
// import { NodeSectionConfig } from './types';

// type NodeTileSectionProps = NodeSectionConfig & {
//   /** Component to use as the tile */
//   TileComponent?: React.ReactNode,
// };

const NodeTileSectionCmp = ({ name, nodes = [], tileSection, TileComponent = NodeTile }) => (
  <StyledNodeTileSection data-test={`node-tile-section-${tileSection}`}>
    <NodeTypeLabel>{name}</NodeTypeLabel>
    <NodeTiles>
      {nodes.map((node, index) => (
        <TileComponent
          key={`node-tile-${index}`}
          name={node?.name}
          testClass={node?.data?.nodeData?.nodeClass}
          accentColor={node?.accentColor}
          Icon={node?.icon}
          IconCategory={node?.iconCategory}
          node={node}
        >
          {node.name}
        </TileComponent>
      ))}
    </NodeTiles>
  </StyledNodeTileSection>
);

export const NodeTileSection = React.memo(NodeTileSectionCmp);

export default NodeTileSection;
